import * as React from 'react'
import { ColumnOption } from '../types'

interface ColumnOptionsHiddenInputsProps {
  prefix: string
  options: ColumnOption[]
}

export default function ColumnOptionsHiddenInputs({ prefix, options }: ColumnOptionsHiddenInputsProps) {
  return (
    <>
      {options.map((option, optIndex) => {
        const optPrefix = `${prefix}[column_options_attributes][${optIndex}]`
        const isExisting = typeof option.id === 'number'

        if (option._destroy) {
          return (
            <span key={`${option.id}-${optIndex}`}>
              {isExisting && (
                <input type="hidden" name={`${optPrefix}[id]`} value={option.id} />
              )}
              <input type="hidden" name={`${optPrefix}[_destroy]`} value="1" />
            </span>
          )
        }

        return (
          <span key={`${option.id}-${optIndex}`}>
            {isExisting && (
              <input type="hidden" name={`${optPrefix}[id]`} value={option.id} />
            )}
            <input type="hidden" name={`${optPrefix}[label]`} value={option.label} />
            <input type="hidden" name={`${optPrefix}[value]`} value={option.value || ''} />
            {option.color && (
              <input type="hidden" name={`${optPrefix}[color]`} value={option.color} />
            )}
            <input type="hidden" name={`${optPrefix}[position]`} value={option.position} />
          </span>
        )
      })}
    </>
  )
}
